/* ==========================================================================
                              INFINITE SCROLL — v3
   ========================================================================== */

class InfiniteScroll extends HTMLElement {
  constructor () {
    super();

    this.button         = this.querySelector('button');
    this.loadingOverlay = this.querySelector('.loading-overlay');
    this.nextUrl        = this.dataset.nextUrl || null;
    this.triggerType    = this.dataset.triggerType;             // "button" | "infinite"
    this.isLoading      = false;

    /* — button «load more» — */
    if (this.button) {
      this.button.addEventListener('click', () => this.fetchNextPage());
    }

    if (this.triggerType === 'infinite') { this.initObserver(); }
  }

  /* ---------- IntersectionObserver ---------- */
  initObserver () {
    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) { this.fetchNextPage(); }
      });
    }, { threshold: 0.5 });

    this.observer.observe(this);
  }

  /* ---------- Load new page ---------- */
  async fetchNextPage () {
    if (this.isLoading || !this.nextUrl) { return; }

    this.isLoading = true;
    this.toggleLoadingState(true);

    try {
      const htmlText    = await fetch(this.nextUrl).then(r => r.text());
      const html        = new DOMParser().parseFromString(htmlText, 'text/html');

      const newGrid       = html.getElementById('product-grid-ajax');
      const newPagination = html.getElementById('pagination-ajax');

      /* --- update DOM --- */
      document.getElementById('product-grid-ajax')
              .insertAdjacentHTML('beforeend', newGrid.innerHTML);

      document.getElementById('pagination-ajax').innerHTML =
              newPagination.innerHTML;

      /* --- next URL --- */
      const nextBtn = newPagination.querySelector('[data-next-url]');
      this.nextUrl  = nextBtn ? nextBtn.dataset.nextUrl : null;

      /* --- if end — disconect observer --- */
      if (!this.nextUrl && this.observer) { this.observer.disconnect(); }

    } catch (err) {
      console.error('Infinite Scroll error:', err);
    } finally {
      this.toggleLoadingState(false);
      this.isLoading = false;

      if (!this.nextUrl && this.button) { this.button.remove(); }
    }
  }

  /* ---------- UI ---------- */
  toggleLoadingState (state) {
    if (!this.button) return;
    this.button.classList.toggle('loading', state);
    if (this.loadingOverlay) {
      this.loadingOverlay.classList.toggle('hidden', !state);
    }
  }
}

customElements.define('infinite-scroll', InfiniteScroll);
